<div class="max-width-500">
  <form
    [formGroup]="passwordForm"
    (ngSubmit)="modifyPassword()"
  >
    <ion-grid fixed="true">
      <ion-row>
        <ion-col size="12">
          <div class="login-box block-content-round">
            <lib-login-logo></lib-login-logo>

            <ion-list lines="none">
              <ion-item>
                <div>
                  <h2 class="ion-margin-top-0 ion-text-center">{{ 'account.change_password_request' | translate }}</h2>
                </div>
              </ion-item>

              <ion-item>
                <ion-input
                  formControlName="email"
                  type="text"
                  label="{{ 'users.email' | translate }}"
                  labelPlacement="floating"
                  placeholder="{{ 'users.email' | translate }}"
                  fill="outline"
                  mode="md"
                  [clearOnEdit]="false"
                  [helperText]="changePasswordRequestHelperText"
                  [errorText]="changePasswordRequestErrorText"
                ></ion-input>
              </ion-item>

              <ion-item>
                <ion-input
                  formControlName="key"
                  type="text"
                  label="{{ 'account.key' | translate }}"
                  labelPlacement="floating"
                  placeholder="{{ 'account.key' | translate }}"
                  fill="outline"
                  mode="md"
                  [clearOnEdit]="false"
                  [helperText]="keyHelperText"
                  [errorText]="keyErrorText"
                ></ion-input>
              </ion-item>

              <ion-item>
                <ion-input
                  formControlName="newPassword"
                  type="password"
                  label="{{ 'account.new_password' | translate }}"
                  labelPlacement="floating"
                  placeholder="{{ 'account.new_password' | translate }}"
                  fill="outline"
                  mode="md"
                  [clearOnEdit]="false"
                  [helperText]="newPasswordHelperText"
                  [errorText]="newPasswordErrorText"
                >
                  <ion-input-password-toggle slot="end"></ion-input-password-toggle>
                </ion-input>
              </ion-item>

              <ion-item>
                <ion-input
                  formControlName="newPasswordRepeat"
                  type="password"
                  label="{{ 'account.repeat_new_password' | translate }}"
                  labelPlacement="floating"
                  placeholder="{{ 'account.repeat_new_password' | translate }}"
                  fill="outline"
                  mode="md"
                  [clearOnEdit]="false"
                  [helperText]="newPasswordRepeatHelperText"
                  [errorText]="newPasswordRepeatErrorText"
                >
                  <ion-input-password-toggle slot="end"></ion-input-password-toggle>
                </ion-input>
              </ion-item>

              @if (errorMessage()) {
                <ion-item>
                  <div class="errors">
                    {{ errorMessage() }}
                  </div>
                </ion-item>
              }

              @if (isDesktopView()) {
                <ion-item class="ion-margin-top">
                  <div>
                    <ion-button
                      expand="block"
                      type="submit"
                      fill="solid"
                      size="default"
                      [disabled]="isOffline()"
                    >
                      {{ 'account.change_password' | translate }}
                    </ion-button>
                  </div>
                </ion-item>
              }

              <ion-item class="ion-margin-vertical">
                <div class="ion-text-center fs-sm ion-margin-top">
                  <a [routerLink]="['/login']">
                    {{ 'login.back_to_login' | translate }}
                  </a>
                </div>
              </ion-item>
            </ion-list>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</div>
